// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  droidId: __t.u64().primaryKey().name("droid_id"),
  owner: __t.identity(),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  name: __t.string(),
  quality: __t.u32(),
  posX: __t.f32().name("pos_x"),
  posZ: __t.f32().name("pos_z"),
  yaw: __t.f32(),
  homeX: __t.f32().name("home_x"),
  homeZ: __t.f32().name("home_z"),
  mode: __t.string(),
  programSrc: __t.string().name("program_src"),
  programJson: __t.string().name("program_json"),
  pc: __t.u32(),
  waitUntilMicros: __t.u64().name("wait_until_micros"),
  patrolPhase: __t.f32().name("patrol_phase"),
  logJson: __t.string().name("log_json"),
  packedItemJson: __t.string().name("packed_item_json"),
  deployedAt: __t.timestamp().name("deployed_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
